var MimeTypes = {
    Image: 'uri/image',
    PlainText: 'text/plain',
    File: 'uri/file',
};
var MessageTypes = {
    Message: 'message',
    Templates: {
        Standard: 'template/standard-event',
        Form: 'template/form',
        Minimal: 'template/minimal',
        Custom: 'template/custom',
    },
};
var MessageDirections = {
    Outgoing: 'right',
    Incoming: 'left',
    System: 'center',
};
var MessageOrientation = {
    Portrait: 'portrait',
    Landscape: 'landscape',
};
var MessageSendStatus;
(function (MessageSendStatus) {
    MessageSendStatus["SENT"] = "SENT";
    MessageSendStatus["SENDING"] = "SENDING";
    MessageSendStatus["FAILED"] = "FAILED";
})(MessageSendStatus || (MessageSendStatus = {}));
var experiments = {
    CrmmChatRenderOfflineActivity: 'specs.woa.CrmmChatRenderOfflineActivity',
    CrmmChatShowCartIndicator: 'specs.woa.CrmmChatShowCartIndicator',
    GlobalUnreadRoomsCounter: 'specs.chat.GlobalUnreadRoomsCounter',
    UnseenMessagesButton: 'specs.chat.UnseenMessagesButton',
    AvailabilityHours: 'specs.chat.AvailabilityHours',
    LazyLoadEmojiPanel: 'specs.chat.LazyLoadEmojiPanel',
    UxEnhacements: 'specs.chat.UxEnhacements',
    ShowCTAButtonForOldDataFormat: 'specs.com.ShowCTAButtonForOldDataFormat',
    ChatDebugMeasureTimeToPush: 'specs.woa.ChatDebugMeasureTimeToPush',
    EnrichedChatroom: 'specs.chat.ChatroomParticipants',
    DrillInMessageIndications: 'specs.chat.DrillInMessageIndications',
    NoHistoryOnRealtimeConnect: 'specs.chat.NoHistoryOnRealtimeConnect',
    UnseenChatroomCount: 'specs.chat.UnseenChatroomCount',
    InboxErrorIndications: 'specs.chat.InboxErrorIndications',
    FetchChatroomsPageSize: 'specs.chat.FetchChatroomsPageSize',
    DBStorage: 'specs.chat.DBStorage',
    MessageGroupingNewTime: 'specs.chat.messageGroupingNewTime',
    FirebaseAtomicServerTime: 'specs.chat.FirebaseAtomicServerTime',
    DragNDropUpload: 'specs.chat.DragNDropUpload',
    DragNDropUploadInbox: 'specs.chat.DragNDropUploadInbox',
    UseRepository: 'specs.chat.SdkUseRepository',
    UnreadBreakdown: 'specs.chat.SdkUnreadBreakdown',
    UnreadableSequence: 'specs.chat.SdkUnreadableSequence',
};
var MediaProviders = {
    WIX_MEDIA: 'WixMedia',
    WIX_MEDIA_PUBLIC: 'WixMediaPublic',
};
var MessagePositionInGroup = {
    START: 'start',
    MIDDLE: 'middle',
    END: 'end',
    SINGLE: 'single',
};
var HistorySinceRealtimeConnectionWasEstablished = 30000;
var FetchChatroomsPageSizeDefaultValue = '30';
var FetchChatroomsPageSizeDefaultValueInt = parseInt(FetchChatroomsPageSizeDefaultValue);
var FetchRoomMessagesPageSize = 50;
var FetchMasterPagePageSize = 30;
var IndicationEvent;
(function (IndicationEvent) {
    IndicationEvent["SENT"] = "Sent";
    IndicationEvent["SEEN"] = "Seen";
    IndicationEvent["FAILED"] = "Failed";
})(IndicationEvent || (IndicationEvent = {}));
var DEFAULT_THROTTLE_THRESHOLD = 5 * 1000;
export { MimeTypes, MessageTypes, MessageDirections, MessageSendStatus, MessageOrientation, experiments, MediaProviders, MessagePositionInGroup, HistorySinceRealtimeConnectionWasEstablished, IndicationEvent, FetchChatroomsPageSizeDefaultValue, FetchChatroomsPageSizeDefaultValueInt, FetchMasterPagePageSize, FetchRoomMessagesPageSize, DEFAULT_THROTTLE_THRESHOLD, };
